import { ModelBase } from '@framework/models/base/base.model';
import { UserContextModel } from '../../auth-models';

export class LoginGoogleOutputApiModel extends ModelBase {
    public userContext: UserContextModel;
    constructor(init?: Partial<LoginGoogleOutputApiModel>) {
        super(init);
        Object.assign(this, init);
    }
}